// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"169":"23a6748c","449":"a7e38248","543":"a7e38248"}[chunkId] + ".chunk.css";
};